import { retry, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { throwAsyncError } from './throwAsyncError';

// re-throw the error with throwAsyncError
// and re-subscribe to the observable, so the subscription isn't closed
// The main use of this is for subscribing down the line to hot observables,
// and you want to handle the errors, but you don't want to close the subscription for
// future emitted values
export function retryAndRethrow<T>(onError?: (err: unknown) => void) {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      tap({
        error: (e: unknown) => {
          throwAsyncError(e);
          onError?.(e);
        },
      }),
      retry(),
    );
  };
}


// todo: create similar operator that uses materialize/dematerialize to
// filter out and re-throw errors globally, and then keep the stream alive;
// which may help in cases where the re-subscribe is hitting a replayed value which is then
// triggering a request down the line.
// Maybe this won't even work??
